<script lang="ts" setup>
import { ref } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid'
import { ClaimDocuments, File } from '@/interfaces/data-contracts';
import PdfViewer from './PdfViewer.vue';

const props = defineProps<{
  data?: any;
  file: File
}>();
const emits = defineEmits(['close']);

const open = ref(true)
</script>
<template>
  <TransitionRoot as="template" :show="Boolean(data)">
    <Dialog as="div" class="relative z-10" @close="emits('close')" :static="true">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex items-end justify-center min-h-full py-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative w-full overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl lg:w-3/5">
              <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block"  @close="emits('close')">
                <button type="button" class="text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" @click="emits('close')">
                  <span class="sr-only">Close</span>
                  <XMarkIcon class="w-6 h-6" aria-hidden="true" />
                </button>
              </div>
              <div class="flex items-center p-4">
                <p class="my-2 text-lg text-gray-800">{{ file.name }}</p>
                <span v-if="file.boxFileId" class="px-5 text-lg text-gray-600">|</span>
                <a v-if="file.boxFileId" target="_blank"
                  :href="`https://upclaim.app.box.com/file/${file.boxFileId}`"
                  class="rounded-md inline-flex bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  <ArrowTopRightOnSquareIcon class="pr-2 text-gray-700 w-7" />
                  Ouvrir dans Box
                </a>
              </div>
              <!-- <embed :src="file.fileUrl" :title="file.filename" type="application/pdf" width="100%" zoom="80%" class=" h-[60vh]"> -->
              <PdfViewer :src="data" :title="file.name" type="application/pdf" width="100%" zoom="80%" class=" h-[80vh]" />
              <!-- <div class="sm:flex sm:items-start"
                <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                  <ExclamationTriangleIcon class="w-6 h-6 text-red-600" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Deactivate account</DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">Are you sure you want to deactivate your account? All of your data will be permanently removed from our servers forever. This action cannot be undone.</p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button type="button" class="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white bg-red-600 rounded-md shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto" @click="open = false">Deactivate</button>
                <button type="button" class="inline-flex justify-center w-full px-3 py-2 mt-3 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" @click="open = false">Cancel</button>
              </div> -->
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>